import type { TerritoryRepository } from '../../application/TerritoryRepository'
import type { TerritoryResult } from '../../domain/territory'

/**
 * Aucun point n'est simulé : une carte de territoire inventée induirait en
 * erreur sur la densité réelle, qui est précisément ce qu'elle sert à lire.
 */
export function createFixtureTerritoryRepository(
  source: 'fixtures' | 'fixture-fallback' = 'fixtures',
): TerritoryRepository {
  return {
    load(): Promise<TerritoryResult> {
      return Promise.resolve({
        points: [],
        routes: [],
        summary: { clients: 0, pendingQuotes: 0, lostQuotes: 0, unlocated: 0, competitors: [] },
        meta: { source, retrievedAt: new Date().toISOString() },
      })
    },
  }
}
